import React from 'react';
import { CssBaseline, Grid } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import ProgramScientific from './ProgramScientific';

// import Preparing from '../components/Preparing';

class ProgramPage extends React.Component {
  componentDidMount() {
    // if (sessionStorage.getItem('_in_role') !== 'SCRL_MGR') {
    //   this.props.history.push('/');
    // }
  }

  render() {
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={1} SIdx={1} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Scientific Program</MainTitle>
            </Grid>
            <Grid item xs={8}>
              {/* 2022 CUSTOM :: 본 행사 시간표 적용 */}
              <ProgramScientific />
              {/* <Preparing /> */}
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default ProgramPage;
